module.exports = __webpack_public_path__ + "img/United Kingdom.471fd32b.png";